import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  routes: [{
    path: '/error',
    redirect: '/index'
  }, {
    path: '/',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index'),
    meta: {title: '首页'}
  }, {
    path: '/unit',
    name: 'unit',
    component: () => import('@/views/unit/index'),
    meta: {title: '全部单位'}
  }, {
    path: '/supplier',
    name: 'supplier',
    component: () => import('@/views/supplier/index'),
    meta: {title: '优质供应商'}
  }, {
    path: '/purchase',
    name: 'purchase',
    component: () => import('@/views/purchase/index'),
    meta: {title: '采购需求'}
  },
    {
      path: '/expertRegister',
      name: 'expertRegister',
      component: () => import('@/views/expertRegister/index'),
      meta: {title: '专家注册'}
    },
    {
      path: '/expertLogin',
      name: 'expertLogin',
      component: () => import('@/views/expertLogin/index'),
      meta: {title: '专家登录'}
    },
    {
    path: '/purchase/detail/:orderMainId',
    name: 'purchaseDetail',
    component: () => import('@/views/purchase/detail'),
    meta: {title: '采购需求'}
  },
    {
      name: 'auction',
      path: '/auction',
      component: () => import('@/views/auction/index'),
      meta: {title: '采购结果'}
    },
    {
      name: 'stop',
      path: '/stop',
      component: () => import('@/views/stop/index'),
      meta: {title: '采购终止'}
    },
    {
      name: 'auctionDetail',
      path: '/auction/detail/:orderMainId',
      component: () => import('@/views/auction/detail'),
      meta: {title: '竞价详情'}
    },
    {
      name: 'stopDetail',
      path: '/stop/detail/:orderMainId',
      component: () => import('@/views/stop/detail'),
      meta: {title: '竞价详情'}
    },
    {
    path: '/integration',
    name: 'integration',
    component: () => import('@/views/integration/index'),
    meta: {title: '整合招投标'}
  },
    {
      path: '/integration/detail/:id/:projectId',
      name: 'inDetail',
      component: () => import('@/views/integration/detail'),
      meta: {title: '招标信息'}
    },
    {
    path: '/bidding',
    name: 'bidding',
    component: () => import('@/views/bidding/index'),
    meta: {title: '招标信息'}
  },
    {
    path: '/bidding/detail/:id',
    name: 'biddingDetail',
    component: () => import('@/views/bidding/detail'),
    meta: {title: '招标信息'}
  }, {
    path: '/integrity',
    name: 'integrity',
    component: () => import('@/views/integrity/index'),
    meta: {title: '诚信公告'}
  }, {
    path: '/integrity/detail/:id',
    name: 'integrityDetail',
    component: () => import('@/views/integrity/detail'),
    meta: {title: '诚信公告'}
  }, {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/index'),
    meta: {title: '新闻资讯'}
  }, {
    path: '/news/:newsType',
    name: 'newsMenu',
    component: () => import('@/views/news/index'),
    meta: {title: '新闻资讯'}
  }, {
    path: '/news/:newsType/detail/:newsId',
    name: 'newsDetail',
    component: () => import('@/views/news/index'),
    meta: {title: '新闻资讯'}
  }, {
    path: '/help',
    name: 'help',
    component: () => import('@/views/help/index'),
    meta: {title: '帮助中心'}
  }, {
    path: '/help/:newsType',
    name: 'helpMenu',
    component: () => import('@/views/help/index'),
    meta: {title: '帮助中心'}
  }, {
    path: '/help/:newsType/detail/:helpId',
    name: 'helpDetail',
    component: () => import('@/views/help/index'),
    meta: {title: '帮助中心'}
  // }, {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/about'),
  //   meta: {title: '关于我们'}
  }, {
    path: '/join',
    name: 'join',
    component: () => import('@/views/join/index'),
    meta: {title: '加盟'}
  },
    {
      path: '/allSol',
      name: 'allSol',
      component: () => import('@/views/allSol/index'),
      meta: {title: '全网检索'}
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index'),
      meta: {title: '关于我们'}
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/products/index'),
      meta: {title: '产品服务'}
    },
    {
      path: '/Purchasing',
      name: 'Purchasing',
      component: () => import('@/views/Purchasing/index'),
      meta: {title: '采购信息'}
    },
    {
      path: '/szElectronicBiddingSystem',
      name: 'szElectronicBiddingSystem',
      component: () => import('@/views/szElectronicBiddingSystem/index.vue'),
      meta: {title: '电子招标系统操作手册(深圳大学)'}
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: () => import('@/views/redirect/index'),
      meta: {title: ''}
    },
    {
      path: '/white',
      name: 'white',
      component: () => import('@/views/white/index'),
      meta: {title: ''}
    },
    {
      path: '/cgsp/video',
      name: 'cgspVideo',
      component: () => import('@/views/cgsp/index'),
      meta: {title: ''}
    },
    {
      path: '/cgsp/video/detail',
      name: 'cgspVideoDetail',
      component: () => import('@/views/cgsp/detail.vue'),
      meta: {title: ''}
    },
    {
      path: '/registerManual',
      name: 'registerManual',
      component: () => import('@/views/registerManual/index'),
      meta: {title: ''}
    },
    {
      path: '/productIntroduce/:key/:currentKey/:productNavIndex',
      name: 'productIntroduce',
      component: () => import('@/views/productIntroduce/index'),
      meta: {title: ''}
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 竞采星,竞价网,高校竞价网,医院竞价网,企业竞价网,电子招投标,竞采网,竞价采购网,零星采购,高校招标,仪器设备'
  }

  if (to.matched.length === 0) { // 匹配前往的路由不存在
    from.name ? next({name: from.name}) : next('/error') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
  } else {
    next() // 如果匹配到正确跳转
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js